import axios from "axios";

export default class AuthService {
  static async post(URI, data) {
    return axios
      .post(URI, data)
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }
}



// WEBPACK FOOTER //
// ./src/tools/AuthService.js